import * as React from 'react';
import { connect } from 'react-redux';
import { createRouteNodeSelector } from 'redux-router5';
import {parseSaleFilter, saleFilterParams} from '~/apps/pos/shared/services/qsfilter';
import SalesListHeader from '../../components/sales/SalesListHeader';
import {downloadDetailSalesCSV, downloadSaleCSV} from '~/apps/pos/shared/services/sales';
import {navigate} from "~/router";
import { vaidateAuth } from '~/apps/shared/actions/auth';
import { getToken } from '~/apps/shared/services/token';
import {Features} from "~/apps/shared/consts";


class SalesHeader extends React.Component<any, any> {
  render() {
    const { route: { params }, information, dispatch } = this.props;
    const filter = parseSaleFilter(params);
    const useExportDetailSales = information.entities.features.includes(Features.PROVIDE_LINE_ITEM_DETAILS_ON_CSV_REPORT);

    return (
      <SalesListHeader
        onExport={(dtStart, dtEnd) => {
          downloadSaleCSV(dtStart, dtEnd);
        }}
        onExportDetail={useExportDetailSales ? (dtStart, dtEnd) => {
          downloadDetailSalesCSV(dtStart, dtEnd);
        } : null}
        onCreate={async () => {
          // refresh current user info before new sale popup appear
          await dispatch(vaidateAuth(getToken()));
          navigate('pos.admin.sales.create', saleFilterParams(filter));
        }}
      />
    );
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

const mapStateToProps = (state) => {
  const selector = createRouteNodeSelector('pos.admin');

  return {
    information: state.shared.information,
    ...selector(state)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesHeader) as any;
